<template>
  <div>
    <Top></Top>
    <div class="main">
      <div class="head">
        <div class="logo">
          <router-link to="/">
            www.rakumart-2c.com
          </router-link>
        </div>
        <h2>初めての方</h2>
      </div>
      <div class="content">
        <div class="nav">
          <div class="nav-item" :class="{ index: index == 1 }" @click="getIndex(1)">
            仕入れの流れ
          </div>
          <div class="nav-item" :class="{ index: index == 2 }" @click="getIndex(2)">
            登録方法
          </div>
          <!-- <ul v-show="index == 2">
            <li>
              <a
                href="#hy1"
                @click="index1 = 1"
                :class="{ index1: index1 == 1 }"
                >トップページ</a
              >
            </li>
            <li>
              <a
                href="#hy2"
                @click="index1 = 2"
                :class="{ index1: index1 == 2 }"
                >個人情報記載</a
              >
            </li>
            <li>
              <a
                href="#hy3"
                @click="index1 = 3"
                :class="{ index1: index1 == 3 }"
                >確認</a
              >
            </li>
          </ul> -->
          <div class="nav-item" :class="{ index: index == 3 }" @click="getIndex(3)">
            商品の探し方
          </div>
          <!-- <ul v-show="index == 3">
            <li>
              <a
                href="#sp1"
                @click="index2 = 1"
                :class="{ index1: index2 == 1 }"
                >日本語検索</a
              >
            </li>
            <li>
              <a
                href="#sp2"
                @click="index2 = 2"
                :class="{ index1: index2 == 2 }"
                >中国語検索</a
              >
            </li>
            <li>
              <a
                href="#sp3"
                @click="index2 = 3"
                :class="{ index1: index2 == 3 }"
                >店舗名検索</a
              >
            </li>
            <li>
              <a
                href="#sp4"
                @click="index2 = 4"
                :class="{ index1: index2 == 4 }"
                >URL検索</a
              >
            </li>
          </ul> -->
          <div class="nav-item" :class="{ index: index == 4 }" @click="getIndex(4)">
            注文方法
          </div>
          <!-- <ul v-show="index == 4">

            <li>
              <a
                href="#zw1"
                @click="index3 = 1"
                :class="{ index1: index3 == 1 }"
                >商品追加</a
              >
            </li>
            <li>
              <a
                href="#zw2"
                @click="index3 = 2"
                :class="{ index1: index3 == 2 }"
                >商品選別</a
              >
            </li>
            <li>
              <a
                href="#zw3"
                @click="index3 = 3"
                :class="{ index1: index3 == 3 }"
                >注文書編集</a
              >
            </li>
          </ul> -->
          <div class="nav-item" :class="{ index: index == 7 }" @click="getIndex(7)">
            注文サポートプログラム
          </div>
          <div class="nav-item" :class="{ index: index == 5 }" @click="getIndex(5)">
            配送依頼方法
          </div>
          <div class="nav-item" :class="{ index: index == 6 }" @click="getIndex(6)">
            支払いについて
          </div>
          <!--  -->
          <div class="nav-item" :class="{ index: index == 8 }" @click="getIndex(8)">
            タオバオ、1688アカウント連結、初回ログイン＆パスワード設定
          </div>
        </div>
        <!-- 下单流程 -->
        <div class="container" v-show="index == 1">
          <div class="tree">
            <ul>
              <li>
                <img src="../../assets/img/nb-img1.png" alt />
                <p></p>
                <h3>1</h3>
                <div class="txt">
                  <h4>商品をカートに追加、注文書を提出</h4>
                  <h5>
                    商品をキーワード検索またはアリババ、タオバオのURLで商品検索可能
                  </h5>
                </div>
              </li>
              <li>
                <div class="txt">
                  <h4>注文書を確認、見積提出</h4>
                  <h5>
                    担当者が商品価格と在庫などを確認し、見積りを提出させて頂きます。
                  </h5>
                </div>
                <h3>2</h3>
                <p></p>
                <img src="../../assets/img/nb-img2.png" alt />
              </li>
              <li>
                <img src="../../assets/img/nb-img3.png" alt />
                <p></p>
                <h3>3</h3>
                <div class="txt">
                  <h4>商品代金のお支払い</h4>
                  <h5>商品の数量や単価を再確認し、問題なければお支払い</h5>
                </div>
              </li>
              <li>
                <div class="txt">
                  <h4>買い付け＆商品が弊社倉庫へ到着</h4>
                  <h5>商品を購入、セラーより商品が届くのを待ちます。</h5>
                </div>
                <h3>4</h3>
                <p></p>
                <img src="../../assets/img/nb-img4.png" alt />
              </li>
              <li>
                <img src="../../assets/img/nb-img5.png" alt />
                <p></p>
                <h3>5</h3>
                <div class="txt">
                  <h4>倉庫内容を確認し、発送依頼を提出</h4>
                  <h5>
                    弊社倉庫に商品が届いたら、送り先と発送方法を指定してください。
                  </h5>
                </div>
              </li>
              <li>
                <div class="txt">
                  <h4>送料の見積り</h4>
                  <h5>梱包サイズ・重量を確定し、国際送料見積りを提出。</h5>
                </div>
                <h3>6</h3>
                <p></p>
                <img src="../../assets/img/nb-img6.png" alt />
              </li>
              <li>
                <img src="../../assets/img/nb-img7.png" alt />
                <p></p>
                <h3>7</h3>
                <div class="txt">
                  <h4>国際配送料のお支払い</h4>
                  <h5>問題なければ国際配送料をお支払いください。</h5>
                </div>
              </li>
              <li>
                <div class="txt">
                  <h4>国際出荷</h4>
                  <h5>基本入金確認後、当日に出荷させて頂きます。</h5>
                </div>
                <h3>8</h3>
                <p></p>
                <img src="../../assets/img/nb-img8.png" alt />
              </li>
              <li>
                <img src="../../assets/img/nb-img9.png" alt />
                <p></p>
                <h3>9</h3>
                <div class="txt">
                  <h4>受け取り</h4>
                  <h5>商品に問題がある場合は担当スタッフまでご連絡くだい。</h5>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- 登录方法 -->
        <div class="container1" v-show="index == 2">
          <h6 id="hy1">一、 ①新規会員登録</h6>
          <span>図１</span>
          <img src="../../assets/img/u2.png" alt />
          <h6 id="hy2">
            ①
            個人情報をご記入頂く際に、赤の★がついている項目は必ずご記入ください。
          </h6>
          <h6>
            ②
            ご登録の携帯番号に会員登録用の確認コードが送信されます。日本国内の携帯電話のみ対応になっております
          </h6>
          <h6>ので、間違いなくご記入ください。</h6>
          <h6>
            ③問題なければラクマート利用規約とプライバシーポリシーに同意し、登録ボタンをクリックしてください
          </h6>
          <h6 style="color: #d9001b">
            ④
            確認コードが受け取れない場合は先にチャットワークの追加申請をお願いします。　ID：rakumart_yamaguchi
          </h6>
          <span>図2</span>
          <img src="../../assets/img/u4.png" alt />
        </div>
        <!-- 商品の探し方 -->
        <div class="container1" v-show="index == 3">
          <h5>当サイトにおける商品の探し方は主に4つのパターンがあります。</h5>
          <h6 id="sp1">一、 ① 商品名キーワードで直接検索</h6>
          <span>図１</span>
          <img src="../../assets/img/u0.png" alt />
          <h6>
            ①タオバオ/中国アリババURLを貼り付け検索、同じ商品が表示されます。
          </h6>
          <p style="color: #d9001b">
            ※商品単価について、割引価格等更新されていない場合がございますが、見積時修正させていただきますので、ご安心ください。
          </p>
          <h6>② 中国語または日本語で検索対応可能。</h6>
          <p style="color: #d9001b">
            ※ご希望の商品が検索できない場合はチャットワークより担当者へのお問い合わせも可能です。
          </p>
          <h6>③　商品を写真をクリックし詳細ページへ</h6>
          <span>図2</span>
          <img src="../../assets/img/u5.png" alt />
          <!-- <h6 id="sp2">二、 ① 中国語商品名のキーワードで直接検索</h6>
          <span>図1</span>
          <img src="../../assets/img/gff13.gif" alt />
          <h6 id="sp3">三、 ① 中国語の店舗名で直接検索</h6>
          <h6>② 店舗名または店舗へをクリックすると店舗ページへ行きます</h6>
          <span>図１</span>
          <img src="../../assets/img/gff14.gif" alt />
          <h6 id="sp4">四、 ① タオバオ、アリババURLの直接入力からの検索。</h6>
          <span>図１</span>
          <img src="../../assets/img/gff15.gif" alt /> -->
        </div>
        <!--注文方法 -->
        <div class="container1" v-show="index == 4">
          <h6 id="zw1">①　商品を写真をクリックし詳細ページへ</h6>
          <h6>②　商品カラー、サイズ、数量を選択記入し、買い物かごへ追加</h6>

          <span>図１</span>
          <img src="../../assets/img/u1.png" alt />
          <h6 id="zw2">①　買い物かごよりご希望の商品を選択し、注文書を作成</h6>

          <span>図2</span>
          <img src="../../assets/img/u4 (1).png" alt />
          <h6 id="zw3">
            ①　商品に対する特別注意項目がある場合は備考欄にご記入
          </h6>
          <h6>
            ②　無在庫便をご利用の場合は輸入者および配送先を必ずご記入ください。
          </h6>
          <h6>
            ③　弊社倉庫へ一時的に保存し、改めて各お客様へ配送依頼する場合は
            　　倉庫止めを選び、輸入者と配送先記入せずに提出可能です。
          </h6>

          <span>図3</span>
          <img src="../../assets/img/u7.png" alt />
        </div>
        <!-- 配送依頼方法 -->
        <div class="container1" v-show="index == 5">
          <h6 id="ps1">①マイページで倉庫より配送依頼可能商品を確認</h6>

          <h6>②発送したい商品を選択（チェックを入れる）</h6>
          <h6>
            ③無在庫販売は通常各エンドユーザー様へ発送になります、違う配送先に送る際に、
            別々発送依頼提出をお願い致します。
          </h6>

          <h6>④商品選択後、見積り提出</h6>
          <span>図１</span>
          <img src="../../assets/img/u1 (1).png" alt />

          <h6 id="ps2">①更に商品を追加したい場合は倉庫より商品の追加が可能</h6>
          <h6>
            ②出荷数は黙認で倉庫の残り数量を配送になり、数量の変更は可能です。
          </h6>
          <h6>
            ③住所は輸入者と配送先があり、輸入者は基本お客様の住所または会社の住所（商品の問い合わせ先販売店舗情報）、
            配送先は商品の届先（各エンドユーザー様の住所）になります。
          </h6>
          <h6>④ご希望の配送会社を指定</h6>
          <h6>
            ④配送会社の指定、お任せの場合、当社が発送方法を決めます。（配送先の住所や内容により配送会社を指定をさ
          </h6>

          <h6>⑤問題なければ提出。</h6>
          <span>図2</span>
          <img src="../../assets/img/u4 (2).png" alt />

          <h6 id="ps3">①配送依頼提出後、見積もり中の状態になります。</h6>
          <h6>
            ②無在庫便の場合、弊社で重量とサイズ確認後、
            残高に見積の国際送料を上回るときは自動引き落としさせていただきます。
          </h6>
          <h6>
            ③不足の場合は送料支払い待ちになります。（チャージ後、再度支払い待ち操作してください。）
          </h6>

          <span>図3</span>
          <img src="../../assets/img/u6.png" alt />
          <h6 id="ps4">
            ①発送手配完了後、詳細より追跡番号をクリックしていただければ追跡可能です。
          </h6>

          <span>図4</span>
          <img src="../../assets/img/u7 (1).png" alt />
        </div>
        <!-- 支払いについて -->
        <div class="container1" v-show="index == 6">
          <h6 id="ps1">①マイページのチャージより入金操作可能です。</h6>

          <span>図１</span>
          <img src="../../assets/img/zf1.png" alt />

          <h6 id="ps2">入金方法は２種類ございます。</h6>
          <h6>ドコモSMTBネット銀行(旧住信SBIネット銀行)へ入金</h6>
          <h6>
            ①　入金名義は必ずご記入ください。（弊社の名義ではなく実際振り込み時記載される名義になります）
          </h6>
          <h6>②　実際にネット銀行またはATMより弊社の口座へ振り込み</h6>
          <h6>③　着金確認後、利用可能金額へ反映させていただきます。</h6>

          <h6 style="color: #d9001b">
            ※通常当日反映可能、翌日になっても反映されない場合は担当者までご連絡ください
          </h6>
          <span>図2</span>
          <img src="../../assets/img/zf2.png" alt />

          <h6 id="ps3">ペイパル入金</h6>
          <h6>①　金額をご記入</h6>
          <h6>②　ペイパルサイトへ移行し、支払いを実行</h6>
          <p style="color: #d9001b">
            ※　ペイパルアカウントをお持ちでない場合は先に作成してからご利用ください
            　
          </p>
          <p style="color: #d9001b">
            ※　必ず弊社サイトから金額記入し、ペイパルサイトへ移行して支払いを行ってください、<br />　直接履歴などから送金された場合は残高へ反映できません。
          </p>

          <span>図3</span>
          <img src="../../assets/img/zf3.png" alt />
        </div>
        <!-- 注文サポートプログラム  -->
        <div class="container1 order" v-show="index == 7">
          <h4>#注文サポートプログラム#</h4>
          <p>
            *本拡張機能は Rakumart
            無在庫サイトの検索時のコピー貼り付けの時間を短縮する機能になります。
          </p>
          <div class="order-box">
            <p>通常の場合：</p>
            <div class="orderList">
              <div class="order-item">
                <img src="../../assets/img/course1.png" alt="" />
                <div class="text">
                  <p>1</p>
                  <p>タオバオ検索</p>
                </div>
              </div>
              <div class="order-item">
                <img src="../../assets/img/course1.png" alt="" />
                <div class="text">
                  <p>2</p>
                  <p>URL コピー</p>
                </div>
              </div>
              <div class="order-item">
                <img src="../../assets/img/course1.png" alt="" />
                <div class="text">
                  <p>3</p>
                  <p>Rakumart サイト貼り付け</p>
                </div>
              </div>
              <div class="order-item">
                <img src="../../assets/img/course1.png" alt="" />
                <div class="text">
                  <p>4</p>
                  <p>-再検索</p>
                </div>
              </div>
              <div class="order-item">
                <img src="../../assets/img/course1.png" alt="" />
                <div class="text">
                  <p>5</p>
                  <p>買い物かごへ追加</p>
                </div>
              </div>
            </div>
            <p>こちらご利用の場合：</p>
            <div class="liyongList">
              <ol>
                <li>タオバオ/アリババ詳細画面</li>
                <li>タオバオ/アリババ詳細画面</li>
                <li>タオバオ/アリババ詳細画面</li>
              </ol>
              <ul>
                <li><img src="../../assets/img/course2.png" alt="" /></li>
                <li><img src="../../assets/img/course2.png" alt="" /></li>
                <li><img src="../../assets/img/course2.png" alt="" /></li>
              </ul>
              <ol>
                <li>ボタンクリック</li>
                <li>追加ボタンクリック</li>
                <li>注文ボタンクリック</li>
              </ol>
              <ul>
                <li><img src="../../assets/img/course2.png" alt="" /></li>
                <li><img src="../../assets/img/course2.png" alt="" /></li>
                <li><img src="../../assets/img/course2.png" alt="" /></li>
              </ul>
              <ol>
                <li>Rakumart サイト自動表示</li>
                <li>Rakumart 買い物かごへ自動追加</li>
                <li>Rakumart 注文書作成</li>
              </ol>
            </div>
          </div>
          <h4>#利用方法#</h4>
          <p>1.下記の URL（chrome ウェブストア）よりプログラム追加</p>

          <a href="https://chrome.google.com/webstore/category/extensions?hl=ja" target="_blank">
            ダウンロードへ</a>

          <img src="../../assets/img/course3.png" alt="" />
          <p>
            2.中国アリババまたはタオバオ詳細画面でGORakumartボタン、買い物かごへ追加、注文へ三個のボタンを機能別でご利用可能。
          </p>
          <h6>
            ＊注文へは単品注文時にご利用可能ですが、<br />
            １注文、多数の場合は買い物かごへ追加してから注文書を作成してください。
          </h6>
          <img src="../../assets/img/course4.png" alt="" />
          <p>＊問題ある際は担当者までご連絡ください。</p>
        </div>
        <!--   タオバオ、1688アカウント連結、初回ログイン＆パスワード設定 -->
        <div class="container1" v-show="index == 8">
          <CourseItem />
        </div>

      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Top from "../../components/head/Top";
import Foot from "../../components/foot/Foot";
import CourseItem from './components/Course-item.vue'
export default {
  data() {
    return {
      index: 1,
    };
  },
  components: {
    Top,
    Foot,
    CourseItem
  },
  created() {
    let i = this.$route.query.status;
    if (i) {
      this.index = this.$route.query.status;
    }
  },
  methods: {
    getIndex(i) {
      this.index = i;
      this.$router.push({
        query: (this.$route.query, { status: this.index }),
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.main {
  width: 1200px;
  margin: 0 auto;

  .head {
    overflow: hidden;
    margin: 30px 0 10px;

    .logo {

      height: 145px;
      float: left;
      display: flex;
      justify-content: center;
      align-items: center;
      word-break: break-all;

      a {
        color: #f3c622;
        font-size: 30px;
      }

      img {
        width: 195px;
        height: 145px;
      }
    }

    h2 {
      font-size: 30px;
      font-weight: 700;
      float: left;
      margin-left: 40px;
      line-height: 145px;
    }
  }

  .content {
    overflow: hidden;

    .nav {
      float: left;

      .nav-item {
        width: 200px;
        padding: 20px 0;
        cursor: pointer;

        text-align: center;
        font-size: 18px;
        background: #eaeaea;
        margin-bottom: 5px;
        display: flex;
        justify-content: center;
        align-items: center
      }

      ul {
        li {
          a {
            display: block;
            width: 200px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            margin-bottom: 5px;
            font-size: 16px;
            color: #333;
          }
        }
      }
    }

    .index {
      background: #f3c622 !important;
    }

    .index1 {
      background: #999 !important;
    }

    .container {
      float: left;
      width: 1000px;
      padding: 50px 0;
      margin-bottom: 50px;

      .tree {
        height: 960px;
        width: 6px;
        background: #b4272d;
        margin: 0 auto;
        position: relative;

        ul {
          position: absolute;
          top: -10px;
          left: -490px;

          li {
            width: 980px;
            height: 120px;
            margin-top: -2px;

            img {
              float: left;
              width: 60px;
              height: 60px;
              margin-left: 380px;
            }

            p {
              margin: 25px 0 -10px 5px;
              float: left;
              height: 4px;
              width: 30px;
              background: #f3c622;
            }

            h3 {
              font-size: 20px;
              margin-top: 10px;
              color: #fff;
              float: left;
              background-color: #f3c622;
              width: 36px;
              height: 36px;
              border-radius: 50%;
              line-height: 36px;
              text-align: center;
            }

            .txt {
              float: left;
              margin: -20px 0 0 20px;
              padding: 20px;
              width: 320px;
              height: 52px;
              background: rgba(180, 39, 45, 0.2);
              border-radius: 15px;

              h4 {
                font-size: 16px;
                font-weight: 700;
              }

              h5 {
                font-size: 14px;
              }
            }
          }

          :nth-child(even) {
            .txt {
              margin-left: 100px;
              background: #85d6ea;
            }

            h3 {
              margin-left: 15px;
              background: #85d6ea;
            }

            p {
              background: #85d6ea;
              margin-left: 0;
            }

            img {
              margin-left: 5px;
            }
          }
        }
      }
    }

    .container1 {
      float: left;
      width: 950px;
      margin-left: 50px;
      padding-top: 30px;
      margin-bottom: 50px;

      h5 {
        font-size: 22px;
        margin-bottom: 40px;
      }

      h6 {
        font-size: 18px;
        line-height: 40px;
      }

      span {
        font-size: 18px;
        line-height: 40px;
      }

      img {
        width: 950px;
        margin-bottom: 100px;
      }
    }

    .order {
      .order-box {
        border: 1px solid #ccc;
        padding: 20px 130px 20px 20px;
        margin-bottom: 30px;

        .orderList {
          margin-left: 110px;
          display: flex;
          border-bottom: 1px solid #ccc;
          margin-bottom: 20px;

          .order-item {
            flex: 1;
            margin-right: 20px;
            position: relative;

            img {
              height: 94px;
              width: 120px;
              margin-bottom: 0;
            }

            .text {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;

              p {
                margin-bottom: 5px;
                font-size: 14px;
                text-align: center;
              }
            }
          }
        }

        .liyongList {
          margin-left: 110px;
          font-size: 14px;

          ol {
            display: flex;

            li {
              border: 1px solid #ccc;
              height: 40px;
              line-height: 40px;
              border-radius: 5px;
            }
          }

          ul {
            margin: 10px 0;
            display: flex;

            img {
              width: 20px;
            }
          }

          li {
            flex: 1;
            margin-right: 20px;
            text-align: center;
          }
        }
      }

      h4 {
        margin-bottom: 20px;
        text-align: center;
        font-size: 25px;
        font-weight: 700;
      }

      a {
        display: inline-block;
        width: 120px;
        height: 40px;
        background: #f3c622;
        border-radius: 5px;
        color: #fff;
        font-size: 16px;
        margin: 10px 0;
        line-height: 40px;
      }

      h6 {
        color: #f3c622;
        font-size: 14px;
        line-height: 20px;
      }

      img {
        margin-bottom: 10px;
      }

      p {
        margin-bottom: 20px;
      }
    }
  }
}
</style>